<div class="flex flex-col h-full bg-white overflow-hidden">
  <main class="flex-1 p-5 overflow-hidden">
    <div class="bg-gris-4 rounded-[10px] h-full flex flex-col p-5 gap-8 overflow-y-auto">
      <button type="button" (click)="goBack()"
        class="bg-white self-start border border-gris-3 rounded-[5px] h-[58px] px-5 flex items-center gap-[10px] fg-noir-2 text-[16px] font-medium cursor-pointer hover:bg-gris-4 transition-colors">
        <app-svg class="fg-gris-1 shrink-0" height="20" svgPath="assets/svg/arrow-back.svg" width="20" />
        {{ 'common.back' | translate }}
      </button>

      <p class="fg-noir-2 text-[24px] font-semibold text-center">
        {{ 'settings.title' | translate }}
      </p>

      <div class="grid grid-cols-2 gap-5 max-w-[1150px] w-full mx-auto">
        <!-- Changer d'instance -->
        <div class="bg-white rounded-[10px] p-5 flex items-center gap-5">
          <div class="bg-orange-3 rounded-[9px] size-[70px] flex items-center justify-center shrink-0">
            <img src="assets/images/icones/switch.png" alt="Choose Instance" class="size-[50px] object-contain" />
          </div>
          <div class="flex flex-col gap-1 flex-1 min-w-0">
            <span class="fg-noir-2 text-[18px] font-semibold">
              {{ 'settings.change_instance.title' | translate }}
            </span>
            <p class="fg-gris-1 text-[14px] leading-[20px] m-0">
              {{ 'settings.change_instance.description' | translate }}
            </p>
          </div>
          <button type="button" (click)="switchInstance()"
            class="bg-vert-1 rounded-[5px] h-[58px] px-5 flex items-center justify-center text-white text-[15px] font-semibold cursor-pointer hover:brightness-95 transition-all shrink-0 whitespace-nowrap">
            {{ 'settings.change_instance.switch_button' | translate }}
          </button>
        </div>

        <!-- Autorisations -->
        <div class="bg-white rounded-[10px] p-5 flex items-center gap-5">
          <div class="bg-orange-3 rounded-[9px] size-[70px] flex items-center justify-center shrink-0">
            <img src="assets/images/icones/user-valid.png" alt="Permission" class="size-[50px] object-contain" />
          </div>
          <div class="flex flex-col gap-1 flex-1 min-w-0">
            <span class="fg-noir-2 text-[18px] font-semibold">
              {{ 'settings.permissions.title' | translate }}
            </span>
            <p class="fg-gris-1 text-[14px] leading-[20px] m-0">
              {{ 'settings.permissions.description' | translate }}
            </p>
          </div>
          <button type="button" (click)="manageTerminalPermissions()"
            class="bg-vert-1 rounded-[5px] h-[58px] px-5 flex items-center justify-center text-white text-[15px] font-semibold cursor-pointer hover:brightness-95 transition-all shrink-0 whitespace-nowrap">
            {{ 'settings.permissions.manage_button' | translate }}
          </button>
        </div>

        <!-- Mode de retrait -->
        <div class="bg-white rounded-[10px] p-5 flex items-center gap-5">
          <div class="bg-orange-3 rounded-[9px] size-[70px] flex items-center justify-center shrink-0">
            <img src="assets/images/icones/order-type.png" alt="Order Type" class="size-[50px] object-contain" />
          </div>
          <div class="flex flex-col gap-1 flex-1 min-w-0">
            <span class="fg-noir-2 text-[18px] font-semibold">
              {{ 'settings.delivery_mode.title' | translate }}
            </span>
            <p class="fg-gris-1 text-[14px] leading-[20px] m-0">
              {{ 'settings.delivery_mode.description' | translate }}
            </p>
          </div>
          <div class="flex flex-col gap-3 w-[180px] shrink-0">
            <div class="flex items-center justify-between gap-3 bg-gris-4 rounded-[5px] p-2">
              <span class="fg-noir-2 text-[14px] font-medium">
                {{ 'settings.delivery_mode.dine_in_label' | translate }}
              </span>
              <button type="button" (click)="toggleDineIn()"
                class="relative h-[32px] w-[64px] rounded-full flex items-center transition-colors cursor-pointer px-[4px]"
                [class.bg-vert-1]="dineInEnabled()" [class.bg-gris-3]="!dineInEnabled()">
                <span class="flex-1 text-[11px] font-semibold text-center" [class.text-white]="dineInEnabled()"
                  [class.fg-gris-1]="!dineInEnabled()">
                  {{ (dineInEnabled() ? 'common.yes' : 'common.no') | translate }}
                </span>
                <span class="size-[24px] rounded-full bg-white shrink-0 shadow"
                  [class.order-first]="!dineInEnabled()"></span>
              </button>
            </div>
            <div class="flex items-center justify-between gap-3 bg-gris-4 rounded-[5px] p-2">
              <span class="fg-noir-2 text-[14px] font-medium">
                {{ 'settings.delivery_mode.takeaway_label' | translate }}
              </span>
              <button type="button" (click)="toggleTakeaway()"
                class="relative h-[32px] w-[64px] rounded-full flex items-center transition-colors cursor-pointer px-[4px]"
                [class.bg-vert-1]="takeawayEnabled()" [class.bg-gris-3]="!takeawayEnabled()">
                <span class="flex-1 text-[11px] font-semibold text-center" [class.text-white]="takeawayEnabled()"
                  [class.fg-gris-1]="!takeawayEnabled()">
                  {{ (takeawayEnabled() ? 'common.yes' : 'common.no') | translate }}
                </span>
                <span class="size-[24px] rounded-full bg-white shrink-0 shadow"
                  [class.order-first]="!takeawayEnabled()"></span>
              </button>
            </div>
          </div>
        </div>

        <!-- Paramètres généraux -->
        <div class="bg-white rounded-[10px] p-5 flex items-center gap-5">
          <div class="bg-orange-3 rounded-[9px] size-[70px] flex items-center justify-center shrink-0">
            <img src="assets/images/icones/settings.png" alt="Settings" class="size-[50px] object-contain" />
          </div>
          <div class="flex flex-col gap-1 flex-1 min-w-0">
            <span class="fg-noir-2 text-[18px] font-semibold">
              {{ 'settings.general_settings.title' | translate }}
            </span>
            <p class="fg-gris-1 text-[14px] leading-[20px] m-0">
              {{ 'settings.general_settings.description' | translate }}
            </p>
          </div>
          <button type="button" (click)="goToGeneralSettings()"
            class="bg-vert-1 rounded-[5px] h-[58px] px-5 flex items-center justify-center text-white text-[15px] font-semibold cursor-pointer hover:brightness-95 transition-all shrink-0 whitespace-nowrap">
            {{ 'settings.general_settings.access_button' | translate }}
          </button>
        </div>

        <!-- Sessions de caisse -->
        <div class="bg-white rounded-[10px] p-5 flex items-center gap-5">
          <div class="bg-orange-3 rounded-[9px] size-[70px] flex items-center justify-center shrink-0">
            <app-svg class="fg-noir-2" height="36" svgPath="assets/svg/list.svg" width="36" />
          </div>
          <div class="flex flex-col gap-1 flex-1 min-w-0">
            <span class="fg-noir-2 text-[18px] font-semibold">
              {{ 'settings.sessions.title' | translate }}
            </span>
            <p class="fg-gris-1 text-[14px] leading-[20px] m-0">
              {{ 'settings.sessions.description' | translate }}
            </p>
          </div>
          <button type="button" (click)="goToSessionList()"
            class="bg-vert-1 rounded-[5px] h-[58px] px-5 flex items-center justify-center text-white text-[15px] font-semibold cursor-pointer hover:brightness-95 transition-all shrink-0 whitespace-nowrap">
            {{ 'settings.sessions.access_button' | translate }}
          </button>
        </div>

        <!-- Vider le cache -->
        <div class="bg-white rounded-[10px] p-5 flex items-center gap-5">
          <div class="bg-orange-3 rounded-[9px] size-[70px] flex items-center justify-center shrink-0">
            <app-svg class="fg-rose-1" height="36" svgPath="assets/svg/trash.svg" width="36" />
          </div>
          <div class="flex flex-col gap-1 flex-1 min-w-0">
            <span class="fg-noir-2 text-[18px] font-semibold">
              {{ 'settings.clear_cache.title' | translate }}
            </span>
            <p class="fg-gris-1 text-[14px] leading-[20px] m-0">
              {{ 'settings.clear_cache.description' | translate }}
            </p>
          </div>
          <button type="button" (click)="openClearCacheModal()"
            class="bg-rose-1 rounded-[5px] h-[58px] px-5 flex items-center justify-center text-white text-[15px] font-semibold cursor-pointer hover:brightness-95 transition-all shrink-0 whitespace-nowrap">
            {{ 'settings.clear_cache.button' | translate }}
          </button>
        </div>
      </div>
    </div>
  </main>
</div>

@if (showClearCacheModal()) {
<div class="fixed inset-0 z-50 flex items-center justify-center bg-black/30">
  <app-modal-clear-cache class="w-[500px]" [title]="'modal.clear_cache.title' | translate"
    [subtitle]="'modal.clear_cache.subtitle' | translate" [cancelLabel]="'common.cancel' | translate"
    [confirmLabel]="'common.confirm' | translate" (cancelClick)="closeClearCacheModal()"
    (confirmClick)="confirmClearCache()" />
</div>
}